export const numberFormats = {
  'en-IE': {
    currency: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
      notation: 'standard',
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
  'en-AU': {
    currency: {
      style: 'currency',
      currency: 'AUD',
      notation: 'standard',
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
  'en-CA': {
    currency: {
      style: 'currency',
      currency: 'CAD',
      notation: 'standard',
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
  'en-GB': {
    currency: {
      style: 'currency',
      currency: 'GBP',
      notation: 'standard',
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
} as const // 👈 Cast to avoid TypeScript errors

export const mapCurrencyToLocale = (currency: string) => {
  switch (currency) {
    case 'EUR':
      return 'en-IE'
    case 'USD':
      return 'en-US'
    case 'AUD':
      return 'en-AU'
    case 'CAD':
      return 'en-CA'
    case 'GBP':
      return 'en-GB'
    default:
      return 'en-IE'
  }
}
